export default __webpack_public_path__ + "static/eyemyth-62b339eba758dba7c41695f9496aab6b.png";